import React from 'react';
import { Sidebar as MssSidebar } from '@mss/mss-component-library';

const Sidebar: typeof MssSidebar = ({ ...props }) => <MssSidebar {...props} />;
const SidebarItem: typeof MssSidebar.Item = ({ ...rest }) => (
  <MssSidebar.Item {...rest} />
);
Sidebar.Item = SidebarItem;

export default Sidebar;
